module.exports = __webpack_public_path__ + "static/media/category-menu-1.b90c89f6.webp";